import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_CSP_CONFIG,
  CspConfig,
} from './cspConfig.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getCspConfigList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<CspConfig>> {
  return http.get(`${API_PATH_CSP_CONFIG}/${deliveryFunctionId}`);
}

export function getCspConfig(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<CspConfig>> {
  return http.get(`${API_PATH_CSP_CONFIG}/${deliveryFunctionId}/${id}`);
}

export function createCspConfig(
  deliveryFunctionId: string,
  body: WithAuditDetails<CspConfig>,
): AxiosPromise<ServerResponse<CspConfig>> {
  return http.post(`${API_PATH_CSP_CONFIG}/${deliveryFunctionId}`, body);
}

export function updateCspConfig(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<CspConfig>,
): AxiosPromise<ServerResponse<CspConfig>> {
  return http.put(`${API_PATH_CSP_CONFIG}/${deliveryFunctionId}/${id}`, body);
}

export function deleteCspConfig(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<CspConfig>> {
  return http.delete(`${API_PATH_CSP_CONFIG}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
